import { Button, Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, makeStyles, MenuItem, Paper, Typography } from '@material-ui/core';
import React, { useState } from 'react'
import { SelectValidator, TextValidator, ValidatorForm } from 'react-material-ui-form-validator'
import { CboCentrosMedicos } from '../../cbos/CboCentrosMedicos';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from '../../../hooks/useForm';
import { CboProfesionales } from '../../cbos/CboProfesionales';
import { CboEspecialidades } from '../../cbos/CboEspecialidades';
import { diasSemana, TIPO_PARAMETRIZACION_TURNOS } from '../../../utils/constants';
import { validarSoloUnPermiso } from '../../../helpers/permisos';
import { agregarHorariosMedicos, efectorHorariosUpdateDisabled, fetchHorariosMedicos } from '../../../actions/turnos/efectorHorarios';
import { CONFIGURACIONTURNOS_PERMISOS } from '../../../utils/permisos';
import { ListaHorarios } from './ListaHorarios';


const useStyles = makeStyles((theme) => ({
    root: {
        padding: 10,
        flexGrow: 1,
        marginTop: 10,
    },
    input: {
        padding: 10,
    },
    grid: {
        backgroundColor: theme.palette.background.paper,
    },
    formControl: {
        marginTop: 5,
        minWidth: 120,
        marginLeft: 20,
        margin: theme.spacing(1),
    },
    button: {
        marginLeft: 25,
    },
    buttonActualizar: {
        marginLeft: 25,
    }
}));

const stateInitial = {
    id: 0,
    idProf: '',
    presencial: true,
    teleconsulta: false,
    demanda: false,
    idFrecuencia: '',
    idAlcanceFrecuencia: '',
    horaDesde: '',
    minDesde: '',
    horaHasta: '',
    minHasta: '',
    duracion: '',
    cantSobreTurnos: 0,
    fechaInicio: '',
    fechaFin: '',
    consultorio: '',
    piso: '',
    edadMaxima: '',
    edadMinima: '',
    recepcion: ''
}

const getIteration = (max, min, qtyIteration) => {
    for (var d = [], i = min; i <= max; i += qtyIteration) {
        d.push(i);
    }
    return d;
}

const horas = getIteration(23, 0, 1);
const minutos = getIteration(59, 0, 5);

export const HorariosMedicosHome = (props) => {

    const classes = useStyles();
    const dispatch = useDispatch();

    const { permisos: permisosUser } = useSelector(state => state.auth)
    const { disabled } = useSelector((state) => state.efectorHorarios);
    const { horarios, cargada } = useSelector((state) => state.efectorHorarios);

    const [idEspecialidad, setIdEspecialidad] = useState(null);
    const [idCentroMedico, setIdCentroMedico] = useState(null);
    const [idProfesional, setIdProfesional] = useState(null);
    const [editRegistro, setEditRegistro] = useState(false);
    const [selectedDays, setSelectedDays] = useState(['LU', 'MA', 'MI', 'JU', 'VI']);

    const [formValues, handleInputChange, reset, setearValor, , , , , setearVariosValores] = useForm(stateInitial);
    const { id, teleconsulta, demanda, horaDesde, minDesde, horaHasta, minHasta, consultorio, piso, recepcion } = (formValues);

    const errorDias = ((selectedDays.length === 0) || (editRegistro && selectedDays.length > 1));
    const errorHorario = ((horaHasta && horaDesde && horaDesde > horaHasta) || (horaDesde && horaHasta && horaHasta < horaDesde));


    const handleInputChangeCascada = ({ target }) => {
        switch (target.name) {
            case 'idCentroMedico':
                setIdCentroMedico(target.value);
                setIdProfesional(null);
                setIdEspecialidad(null);
                break;
            case 'idProfesional':
                if (target.value === '') {
                    setIdProfesional(null);
                }
                else {
                    setIdProfesional(target.value);
                    setIdEspecialidad(null);
                }
                break;
            case 'idEspecialidad':
                setIdEspecialidad(target.value);
                break;
            default:
                break;
        }
        editRegistro && reset(stateInitial);
    }


    const handleClick = (dia) => {
        const selectedIndex = selectedDays.indexOf(dia.value);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selectedDays, dia.value);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selectedDays.slice(1));
        } else if (selectedIndex === selectedDays.length - 1) {
            newSelected = newSelected.concat(selectedDays.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selectedDays.slice(0, selectedIndex),
                selectedDays.slice(selectedIndex + 1)
            );
        }
        setSelectedDays(newSelected);
    };

    const doNuevoRegistro = () => {
        reset(stateInitial);
        setEditRegistro(false);
        setSelectedDays(['LU', 'MA', 'MI', 'JU', 'VI']);
        dispatch(efectorHorariosUpdateDisabled(false));
    }

    const handleNuevoRegistro = () => {
                doNuevoRegistro();
    }

    const handleSearch = () => {
        dispatch(efectorHorariosUpdateDisabled(true));
        idEspecialidad && dispatch(fetchHorariosMedicos(idCentroMedico, idProfesional, idEspecialidad));
    }



    const handleSubmit = () => {
        const parametros = {
            id: id,
            idEfector: idProfesional,
            idCentro: idCentroMedico,
            idEspecialidad: idEspecialidad,
            horaDesde: horaDesde,
            minDesde: minDesde,
            horaHasta: horaHasta,
            minHasta: minHasta,
            teleconsulta: teleconsulta,
            piso: piso,
            consultorio: consultorio,
            recepcion: recepcion
        }
        console.log("parametros", parametros);
        dispatch(agregarHorariosMedicos(parametros, selectedDays));
    }

    console.log("editRegistro", editRegistro)
    return (

        <ValidatorForm onSubmit={handleSubmit} instantValidate={true}>
            <div className={classes.root}>
                <Grid container justify="center" spacing={1} style={{ marginTop: 5 }}>
                    <Grid item xs={8} className={classes.grid}>
                        <Grid container direction="row" alignItems="center" spacing={1}>
                            <Grid item xs={12} md={4}>
                                <Paper className={classes.input}>
                                    <CboCentrosMedicos
                                        manejadorInputChange={handleInputChangeCascada}
                                        idCombo={'idCentroMedico'}
                                        filtrarPorUsuario={true}
                                        valor={idCentroMedico}
                                    />
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper className={classes.input}>
                                    <CboProfesionales
                                        manejadorInputChange={handleInputChangeCascada}
                                        idCentroMedico={idCentroMedico}
                                        cargarEnCascada={true}
                                        porCentroMedico={true}
                                        valor={idProfesional}
                                        required={'required'}
                                    />
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper className={classes.input}>
                                    <CboEspecialidades
                                        manejadorInputChange={handleInputChangeCascada}
                                        setIdEspecialidad={setIdEspecialidad}
                                        idCentroMedico={idCentroMedico}
                                        idProfesional={idProfesional}
                                        idTipoParametrizacion={TIPO_PARAMETRIZACION_TURNOS.NORMAL}
                                        cargarEnCascada={true}
                                        valor={idEspecialidad}
                                    />
                                </Paper>
                            </Grid>
                        </Grid>
                        <Grid item container justify="center" style={{ marginTop: 5 }}>
                            <Paper style={{ marginTop: 5 }}>
                                <FormControl required error={errorDias} component="fieldset" >
                                    <FormGroup row>
                                        {diasSemana.map((item) => (
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        name={item.value}
                                                        checked={selectedDays.filter(w => w === item.value).length > 0 ? true : false}
                                                        onClick={() => handleClick(item)}
                                                        disabled={disabled || editRegistro}
                                                    />
                                                }
                                                label={item.display}
                                            />
                                        ))}
                                    </FormGroup>
                                    {errorDias && !editRegistro &&
                                        <FormHelperText style={{ textAlign: 'center' }}>Debe seleccionar por lo menos un día</FormHelperText>
                                    }
                                </FormControl>
                            </Paper>
                        </Grid>
                        <Grid item container justify="center" style={{ marginTop: 5 }}>
                            <Grid item xs={12} md={4}>
                                <Paper style={{ marginRight: 20 }} >
                                    <Typography style={{ textAlign: 'center', marginTop: 20 }} >Admite Teleconsulta</Typography>
                                    <Grid container direction="row" justify="center" spacing={1}>
                                        <Grid item xs={6}>
                                            <FormControl className={classes.formControl} required component="fieldset" >
                                                <FormGroup row>
                                                    <FormControlLabel

                                                        control={
                                                            <Checkbox
                                                                name="teleconsulta"
                                                                checked={teleconsulta}
                                                                disabled={disabled || demanda}
                                                                onChange={(e) => setearValor(e.target.name, e.target.checked)}

                                                            />
                                                        }
                                                        label="Teleconsulta"
                                                    />
                                                </FormGroup>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper style={{ marginRight: 20 }} >
                                    <Typography style={{ textAlign: 'center', marginTop: 20 }} >Hora de Inicio</Typography>
                                    <Grid container direction="row" justify="center" spacing={1}>
                                        <Grid item xs={6}>
                                            <FormControl className={classes.formControl} required error={errorHorario} >
                                                <SelectValidator
                                                    label="Horas"
                                                    name="horaDesde"
                                                    fullWidth={true}
                                                    value={horaDesde}
                                                    disabled={disabled}
                                                    onChange={handleInputChange}
                                                    validators={['required']}
                                                    errorMessages={['Seleccione una opción']}
                                                >
                                                    {horas.map((item) => (
                                                        <MenuItem value={item}>{item}</MenuItem>
                                                    ))}
                                                </SelectValidator>
                                                {errorHorario &&
                                                    <FormHelperText style={{ textAlign: 'center' }}>El valor no puede ser mayor a Hora Hasta </FormHelperText>
                                                }
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl className={classes.formControl}>
                                                <SelectValidator
                                                    label="Minutos"
                                                    name="minDesde"
                                                    fullWidth={true}
                                                    value={minDesde}
                                                    disabled={disabled}
                                                    onChange={handleInputChange}
                                                    validators={['required']}
                                                    errorMessages={['Seleccione una opción']}
                                                >
                                                    {minutos.map((item) => (
                                                        <MenuItem value={item}>{item}</MenuItem>
                                                    ))}
                                                </SelectValidator>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} md={4}>
                                <Paper style={{ marginRight: 20 }} >
                                    <Typography style={{ textAlign: 'center', marginTop: 20 }} >Hora de Finalización</Typography>
                                    <Grid container direction="row" justify="center" spacing={1}>
                                        <Grid item xs={6}>
                                            <FormControl className={classes.formControl} required error={errorHorario}>
                                                <SelectValidator
                                                    label="Horas"
                                                    name="horaHasta"
                                                    fullWidth={true}
                                                    value={horaHasta}
                                                    disabled={disabled}
                                                    onChange={handleInputChange}
                                                    validators={['required']}
                                                    errorMessages={['Seleccione una opción']}
                                                >
                                                    {horas.map((item) => (
                                                        <MenuItem value={item}>{item}</MenuItem>
                                                    ))}
                                                </SelectValidator>
                                                {errorHorario &&
                                                    <FormHelperText style={{ textAlign: 'center' }}>El valor no puede ser menor a Hora Desde </FormHelperText>
                                                }
                                            </FormControl>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <FormControl className={classes.formControl}>
                                                <SelectValidator
                                                    label="Minutos"
                                                    name="minHasta"
                                                    fullWidth={true}
                                                    value={minHasta}
                                                    disabled={disabled}
                                                    onChange={handleInputChange}
                                                    validators={['required']}
                                                    errorMessages={['Seleccione una opción']}
                                                >
                                                    {minutos.map((item) => (
                                                        <MenuItem value={item}>{item}</MenuItem>
                                                    ))}
                                                </SelectValidator>
                                            </FormControl>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid container direction="row" justify="center" spacing={1} style={{ marginTop: 20, marginBottom: 5 }}>
                                <Grid item xs={12} md={6}>
                                    <Paper>
                                        <Grid container direction="row" justify="center" spacing={1} style={{ marginTop: 10 }}>
                                            <Grid item xs={3}>
                                                <Typography style={{ textAlign: 'center' }} >Piso</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <TextValidator
                                                        variant="outlined"
                                                        margin='normal'
                                                        fullWidth
                                                        label="Piso"
                                                        autoComplete="off"
                                                        name="piso"
                                                        value={piso}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        validators={["maxStringLength:4"]}
                                                        errorMessages={["Máximo 4 caracteres"]}
                                                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography style={{ textAlign: 'center' }} >Consultorio</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <TextValidator
                                                        variant="outlined"
                                                        margin='normal'
                                                        fullWidth
                                                        label="Consultorio"
                                                        autoComplete="off"
                                                        name="consultorio"
                                                        value={consultorio}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={3}>
                                                <Typography style={{ textAlign: 'center' }} >Recepcion</Typography>
                                                <FormControl className={classes.formControl}>
                                                    <TextValidator
                                                        variant="outlined"
                                                        margin='normal'
                                                        fullWidth
                                                        label="Recepcion"
                                                        autoComplete="off"
                                                        name="recepcion"
                                                        value={recepcion}
                                                        disabled={disabled}
                                                        onChange={handleInputChange}
                                                        InputLabelProps={{ style: { fontWeight: 'bold' } }}
                                                    />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                    </Paper>
                                </Grid>
                            </Grid>
                            <Grid container direction="row" justify="center" spacing={1} style={{ marginTop: 20, marginBottom: 5 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={idEspecialidad === null}
                                    className={classes.button}
                                    onClick={handleSearch}
                                >
                                    Buscar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={disabled || (errorDias || errorHorario)}
                                    className={classes.button}
                                    type='submit'
                                >
                                    Grabar
                                </Button>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    className={classes.button}
                                    disabled={!validarSoloUnPermiso(permisosUser, CONFIGURACIONTURNOS_PERMISOS.ALTA) || !idCentroMedico || !idProfesional || !idEspecialidad}
                                    onClick={handleNuevoRegistro}
                                >
                                    Nuevo
                                </Button>
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid container className={classes.root} justify="center" spacing={1}>
                        <Grid item xs={11} className={classes.grid}>
                            <ListaHorarios
                                cargada={cargada}
                                permisosUser={permisosUser}
                                setSelectedDays={setSelectedDays}
                                setEditRegistro={setEditRegistro}
                                setearVariosValores={setearVariosValores}
                                items={horarios}
                                // items={items.filter(s => !s.inHabilitado)}
                                validarSoloUnPermiso={validarSoloUnPermiso}
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </div>
        </ValidatorForm>
    )
}
